// extracted by mini-css-extract-plugin
export var again = "flowStepPhoneVerify-module--again--d0612";
export var btn = "flowStepPhoneVerify-module--btn--07264";
export var digit = "flowStepPhoneVerify-module--digit--7a155";
export var digits = "flowStepPhoneVerify-module--digits--3b7e1";
export var error = "flowStepPhoneVerify-module--error--3cc51";
export var inner = "flowStepPhoneVerify-module--inner--20b83";
export var phone = "flowStepPhoneVerify-module--phone--d1981";
export var subtitle = "flowStepPhoneVerify-module--subtitle--85872";